import Tab from './components/tab';
import Gauge from './components/gauge'
import Quick from './components/quick'

$(document).ready(function () {
    init();
});

function init(){
    window.Tab = new Tab('.tab');
    window.gauge = Gauge;

    Quick();
    banner();
}


function banner(){
    $(document).on('click', '.banner__btn', ()=>{
        $('.banner').fadeOut(200);
    })
}



// WEBPACK FOOTER //
// ./src/js/index.js